import {
  FormControlLabel,
  Checkbox,
  TextField,
  Box,
  Card,
  CardMedia,
  Typography,
  Button,
} from '@mui/material';
import React, { useState } from 'react';
import { blobUrl } from '../Constants';
import WarningIcon from '@mui/icons-material/Warning';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import DeleteIcon from '@mui/icons-material/Delete';
import { ArtistMedia } from '../@types/api';

interface Props {
  media: ArtistMedia;
  onSaveMedia: (media: ArtistMedia) => void;
  onRemoveMedia: (media: ArtistMedia) => void;
  isSelected: boolean;
}
const ArtistMediaCard: React.FC<Props> = ({
  media,
  onSaveMedia,
  onRemoveMedia,
  isSelected,
}) => {
  const [orderIndex, setOrderIndex] = useState<number>(media.orderIndex);
  const [isLive, setIsLive] = useState<boolean>(media.isLive);
  const [shouldDelete, setShouldDelete] = useState<boolean>(false);
  const isDirty =
    shouldDelete || orderIndex !== media.orderIndex || isLive !== media.isLive;

  const imageUrl = media.upload
    ? `${blobUrl}/images/${media.upload.fileName}`
    : undefined;

  const handleSave = () => {
    const updatedMedia = {
      ...media,
      isLive,
      orderIndex,
    };
    onSaveMedia(updatedMedia);
  };

  const handleDelete = () => {
    onRemoveMedia(media);
  };

  const handleReset = () => {
    setIsLive(media.isLive);
    setOrderIndex(media.orderIndex);
    setShouldDelete(false);
  };

  return (
    <>
      <Card sx={{ maxWidth: 345 }} raised={isSelected}>
        <Box
          pt={1}
          style={{
            position: 'relative',
          }}
        >
          <CardMedia
            component='img'
            height='200'
            image={imageUrl}
            alt={media.upload?.altText}
            sx={{
              objectFit: 'cover',
              objectPosition: 'center top',
            }}
          />
          <Typography p={1} sx={{ height: 60 }}>
            {media.upload?.altText}
          </Typography>
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%', p: 1 }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isLive}
                onChange={() => setIsLive(!isLive)}
                disabled={!isSelected}
              />
            }
            label='Live'
          />
          <TextField
            label='Order'
            disabled={!isSelected}
            type='number'
            variant='outlined'
            value={orderIndex}
            onChange={(e) => setOrderIndex(Number(e.currentTarget.value))}
            InputProps={{ inputProps: { min: 0 } }}
            size='small'
            sx={{ maxWidth: 60 }}
          />
        </Box>

        <Box
          justifyContent='space-between'
          display='flex'
          alignItems='center'
          sx={{ width: '100%' }}
        >
          <Button
            aria-label='cancel'
            onClick={handleReset}
            disabled={!isDirty}
            title='cancel'
            startIcon={
              <CancelIcon color={isDirty ? 'secondary' : 'disabled'} />
            }
          >
            Undo
          </Button>
          <Button
            aria-label='delete'
            onClick={handleDelete}
            title='delete'
            startIcon={<DeleteIcon color={'warning'} />}
          >
            Delete
          </Button>
          {isDirty && <WarningIcon color='warning' />}
          <Button
            aria-label='save'
            onClick={handleSave}
            title='save changes'
            startIcon={<SaveIcon color={isDirty ? 'action' : 'disabled'} />}
          >
            Save
          </Button>
        </Box>
      </Card>
    </>
  );
};

export default ArtistMediaCard;
